import ServiceApi from "../services/service.api";
import React, { useState } from 'react'

const baseServiceUrl = `/api/v1/OrdersService`;


const ApiOrderService = {
  getAll: (params) => {
    const url = `${baseServiceUrl}/getAll`;
    return ServiceApi.get(url, { params });
  },

  GetItemForWaranty: (params) => {
    const url = `${baseServiceUrl}/GetItemForWaranty?BasketId=` + params.basketId + `&` + params.listBasketItemPersonID
    return ServiceApi.get(url)
  },
  getItemWithDetails: (params) => {
    const url = `${baseServiceUrl}/getItemWithDetails?BasketId=` + params.basketId + `&` + params.listBasketItemPersonID
    return ServiceApi.get(url)
  },

  getBasketCanceledOrder: (params) => {
    const url = `${baseServiceUrl}/getAllCanceledOrder`;
    return ServiceApi.get(url, { params });
  },
  get: (id) => {
    const url = `${baseServiceUrl}/${id}`;
    return ServiceApi.get(url);
  },
  getBasketPayment: (params) => {
    const url = `${baseServiceUrl}/getBasketPayment`;
    return ServiceApi.get(url, { params });
  },
  getAllOrdersByExcel: (params) => {
    const url = `${baseServiceUrl}/getAllOrdersByExcel`;
    return ServiceApi.get(url, { params: params, responseType: 'blob' });
  },
  sendSmsLinkAddress: (params) => {
    const url = `${baseServiceUrl}/sendSmsLinkAddress`;
    return ServiceApi.get(url, { params });
  },
  sendSmsOrderStatus: (params) => {
    const url = `${baseServiceUrl}/sendSmsOrderStatus`;
    return ServiceApi.get(url, { params });
  },
  // createBasket: (params) => {
  //   const url = `${baseServiceUrl}/createBasket`;
  //   return ServiceApi.post(url, params);
  // },
  // createItemBasket: (params) => {
  //   const url = `${baseServiceUrl}/addOrEditeBasket`;
  //   return ServiceApi.post(url, params);
  // },
  PayToWaranty: (params) => {
    const url = `${baseServiceUrl}/PayToWaranty`;
    return ServiceApi.post(url, params);
  },
  ReceiveFromWaranty: (params) => {
    const url = `${baseServiceUrl}/ReceiveFromWaranty`;
    return ServiceApi.post(url, params);
  },
  changeBasketItemPersonCancelStatus: (params) => {
    const url = `${baseServiceUrl}/changeBasketItemPersonCancelStatus`;
    return ServiceApi.put(url, params);
  },
  changeBasketItemPersonSupplierCancelStatus: (params) => {
    const url = `${baseServiceUrl}/changeBasketItemPersonSupplierCancelStatus`;
    return ServiceApi.put(url, params);
  },
  updateBasketItemPersonFineAmount: (params) => {
    const url = `${baseServiceUrl}/updateBasketItemPersonFineAmount`;
    return ServiceApi.put(url, params);
  },
  getBasketById: (id) => {
    const url = `${baseServiceUrl}/getBasketById?id=` + id;
    return ServiceApi.get(url);
  },
  GetCanceldBasketById: (id) => {
    const url = `${baseServiceUrl}/GetCanceldBasketById?basketId=` + id;
    return ServiceApi.get(url);
  },
  update: (data) => {
    const url = `${baseServiceUrl}/ChangeBasketItemPersonCurrentStatus`;
    return ServiceApi.put(url, data);
  },
  updatePersons: (data) => {
    const url = `${baseServiceUrl}/CreateUpdateBasketItemPerson`;
    return ServiceApi.put(url, data);
  },
  BasketReport: (params) => {
    const url = `${baseServiceUrl}/basketReport`;
    return ServiceApi.get(url, { params });
  },
  GetEnumsName: (params) => {
    const url = `${baseServiceUrl}/getEnumsName?enumsName=` + params;
    return ServiceApi.get(url);
  },

  issueTicket: (data) => {
    const url = `${baseServiceUrl}/IssueTicket`;
    return ServiceApi.put(url, data);
  },
  deleteCancellationOperation: (params) => {
    const url = `${baseServiceUrl}/deleteCancellationOperation`;
    return ServiceApi.put(url, params);
  },
  deleteSupplierCancellation: (params) => {
    const url = `${baseServiceUrl}/deleteSupplierCancellation`;
    return ServiceApi.put(url, params);
  },
  resetTicketStatusToReserved: (data) => {
    const url = `${baseServiceUrl}/resetTicketStatusToReserved`;
    return ServiceApi.put(url, data);
  },
};

export default ApiOrderService;


